<template>
	<el-container style="height: 100%">
		<el-aside width="20%">
			<div class="map_dialog" >
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
					<el-tab-pane label="用户" name="user">
						<el-card style="margin-top: 10px">

							<el-row style="text-align: left;">
								<el-col :span="12">
									<el-select clearable :disabled="deptdisable" @change="changeIndex1"  @keyup.enter.native="getUserList" filterable   v-model="form.bmid"  placeholder="大队">
									<el-option
											v-for="item in depts"
											:key="item.bmid"
											:label="item.bmmc"
											:value="item.bmid"
											:disabled="deptdisable">
									</el-option>
								</el-select></el-col>
								<el-col :span="12"><el-input
										@change="changeIndex1"  @keyup.enter.native="getUserList"
										placeholder="姓名"
										v-model="form.name"
										clearable>
								</el-input></el-col>
							</el-row>
							<el-row>
								<el-table :data="userList" v-loading="loading" >
									<el-table-column prop="username" label="工号">
										<template slot-scope="scope">
											<el-button  type="text" @click="selectUser(scope.row)">{{scope.row.username}}</el-button>
										</template>
									</el-table-column>
									<el-table-column prop="xm" label="姓名"></el-table-column>
								</el-table>
								<el-pagination small layout=" pager" :total="total"
											   :page-size="10"
											   :current-page.sync="userCurrentPage"			   @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
							</el-row>
						</el-card>
						<el-card style="margin-top: 30px">
							<div class="text">工号：{{selectuser.username}}</div>
							<div class="text">姓名：{{selectuser.xm}}</div>
							<div class="text">手机号码：{{selectuser.sjhm}}</div>
							<div class="text">部门：{{bm.bmmc}}</div>
							<div class="text">岗点：{{gdmc}}</div>

						</el-card >
					</el-tab-pane>
					<el-tab-pane label="岗点" name="gd">
						<el-card style="margin-top: 10px">

							<el-row style="text-align: left;">
								<el-col :span="12">
									<el-select clearable :disabled="deptdisable" @change="changeIndex2"  @keyup.enter.native="getGdList" filterable   v-model="form1.bmid"  placeholder="大队">
										<el-option
												v-for="item in depts"
												:key="item.bmid"
												:label="item.bmmc"
												:value="item.bmid"
												:disabled="deptdisable1">
										</el-option>
									</el-select></el-col>
								<el-col :span="12"><el-input
										@change="changeIndex2"  @keyup.enter.native="getGdList"
										placeholder="名称"
										v-model="form1.name"
										clearable>
								</el-input></el-col>
							</el-row>
							<el-row>
								<el-table :data="gdList" v-loading="loading1" >
									<el-table-column prop="gdmc" label="名称">
										<template slot-scope="scope">
											<el-button  type="text" @click="selectGd(scope.row)">{{scope.row.gdmc}}</el-button>
										</template>
									</el-table-column>
<!--									<el-table-column prop="xm" label="姓名"></el-table-column>-->
								</el-table>
								<el-pagination small layout=" pager" :total="total1"
											   :page-size="10"
											   :current-page.sync="userCurrentPage1"			   @current-change="pageUser1" style="margin-top: 1rem;"></el-pagination>
							</el-row>
						</el-card>
						<el-card style="margin-top: 30px">
							<div class="text">名称：{{selectgd.gdmc}}</div>
							<div class="text">打卡距离：{{selectgd.dkjl}}</div>
							<div class="text">早班人数：{{selectgd.morrs}}</div>
							<div class="text">早班时间：{{zbsj}}</div>
							<div class="text">中班人数：{{selectgd.aftrs}}</div>
							<div class="text">中班时间：{{aftbsj}}</div>
							<div class="text">晚班班人数：{{selectgd.evers}}</div>
							<div class="text">晚班班时间：{{wbsj}}</div>

						</el-card >
					</el-tab-pane>
				</el-tabs>


			</div>
		</el-aside>
		<el-main>
			<el-amap ref="map" vid="amapDemo" :amap-manager="amapManager" :center="center" :zoom="zoom.zoom"
					 style="position: relative;" :events="events" :logo="false">
				<date-range-picker v-model="time" :locale-data="localeData" :auto-apply="true" style="position: absolute;z-index: 500;top: 20px;left: 20px;" :show-dropdowns="true"	opens="right" :ranges="customerRanges"
				@change-month="changeMonth"
				:max-date="todayFiled"
				@update="getData"
				:time-picker24-hour="true"
				>
					<template #date="data">
						<span :class="hasTraceDays.includes(data.date.getTime()-43200000)?'has_message':''">{{ data.date.getDate()  }}</span>
					</template>
				</date-range-picker>
				<el-amap-polyline :stroke-color="polyline.color"  :editable="polyline.editable"  :path="polyline.path" :events="polyline.events" v-for="polyline in polylines" ></el-amap-polyline>
				<el-amap-marker :vid="marker.id" v-for="(marker,index) in markers" :icon="markr" :position="marker.position[0]" :events="marker.events"></el-amap-marker>
				<el-amap-marker :vid="marker.id" v-for="(marker,index) in markers2" :icon="index==0?startgif:(index==markers2.length-1?endgif:markr)" :position="marker.position[0]" :events="marker.events"></el-amap-marker>
				<el-amap-circle v-for="circle in circles" fill-color="#6495ED" :radius="circle.radius" :fill-opacity="circle.fillOpacity"
								:center="circle.center[0]" :events="circle.events"></el-amap-circle>
				<el-amap-info-window  :position="window.position" :visible="window.visible" :offset="[0,-20]">
					<div>
						<div class="MapPopBox">
							<div class="DeviceInfo">
								<div class="item">
									<ul>
										<li>
											<span class="item-title" v-show="window.info.name">岗点名称：</span>
											<span class="item-info"  v-text="window.info.name"></span>
										</li>
										<li v-show="window.info.placeName">
											<span class="item-title">巡逻点名称：</span>
											<span class="item-info" v-text="window.info.placeName"></span>
										</li>
										<li v-show="window.info.time">
											<span class="item-title">扫码时间：</span>
											<span class="item-info" v-text="window.info.time"></span>
										</li>
										<li v-show="window.info.date">
											<span class="item-title">日期：</span>
											<span class="item-info" v-text="window.info.date"></span>
										</li>
										<li v-show="window.info.userName">
											<span class="item-title">用户：</span>
											<span class="item-info" v-text="window.info.userName"></span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</el-amap-info-window>
			</el-amap>
		</el-main>

	</el-container>
</template>

<script>
	import VueAMap from 'vue-amap'
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import { Loading } from 'element-ui';
	import markr from '../../../assets/bjba/map/mark_r.png'
	import startgif from '../../../assets/bjba/map/start.gif'
	import endgif from '../../../assets/bjba/map/end.gif'
	import DateRangePicker from 'vue2-daterange-picker'
	import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
	let today = new Date()
	today.setHours(0, 0, 0, 0)

	let yesterday = new Date()
	yesterday.setDate(today.getDate() - 1)
	yesterday.setHours(0, 0, 0, 0);

	let weekday = new Date()
	weekday.setDate(today.getDate() - 7)
	weekday.setHours(0, 0, 0, 0);
	@Component({
		name: 'patrol-map',
		components: {
			DateRangePicker
		}
	})
	export default class map extends Vue {
		activeName='user'
		form={
			name:'',
			username:'',
			bmid:''
		}
		form1={
			name:'',
			bmid:''
		}
		depts=[]
		deptdisable=false
		deptdisable1=false
		total= 0
		userCurrentPage=1
		userList=[]
		gdList=[]
		loading1=false
		total1=0
		userCurrentPage1=1
		loading=false
		hasTraceDays=[]
		markr=markr
		startgif=startgif
		endgif=endgif
		amapManager = new VueAMap.AMapManager()
		colorList=['#22782e','#f20c0c','#0c10ae','#1163df','#0805f4']
		time= {
			startDate: weekday,
			endDate: today
		}
		localeData={
			direction: 'ltr',
			format: 'yyyy-mm-dd',
			separator: ' - ',
			applyLabel: '确定',
			cancelLabel: '取消',
			weekLabel: '周',
			customRangeLabel: 'Custom Range1',
			daysOfWeek: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
			monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
			firstDay: 0
		}
		customerRanges={
			'今天': [today, today],
			'昨天': [yesterday, yesterday],
			'本月': [new Date(today.getFullYear(), today.getMonth() , 1), new Date(today.getFullYear(), today.getMonth()+1, 0)],
			'本年': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
			'上个月': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
		}
		polylines= []
		zoom={
			zoom: 12
		}
		events = {
			zoomchange: (e) => {
				this.zoom.zoom=this.$refs.map.$$getInstance().getZoom()
			}
		}
		window={
			position:[121.506377, 31.245105],
			visible: false,
			info: {}
		}
		center = [121.506377, 31.245105]
		markers = []
		markers2 = []
		circles = []
		selectuser={}
		bm={}
		gd=[]
		bcxxForm={
			morbc:{time:['','']},
			aftbc:{time:['','']},
			evebc:{time:['','']}
		}
		selectgd={}
		beginMonth = this.$moment(today).startOf('month').format('YYYY-MM-DD')
		endMonth = this.$moment(today).add(1,'M').endOf('month').format('YYYY-MM-DD')
		todayFiled=today
		mounted() {
			this.init()
			this.getDepts()
		}
		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
				if(this.depts && this.depts[0]) {
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if(zzdyqc != this.CONST_ZN_BM) {
						var zw = this.$store.getters.user.zw;
						if(zw) {
							if(zw=='01'||zw=='02'||zw=='03') {
								this.form.dept = that.depts[0].bmid
								this.form1.bmid = that.depts[0].bmid
								this.deptdisable = true
								this.deptdisable1 = true
							}
						}
					}
				}
				this.getUserList()
				this.getGdList()
			})
		}
		handleClick(tab, event) {
			console.log('111')
			if(tab.index === '0') {
				if(this.hasdata(this.selectuser)) {
					console.log('111')
					this.createuserMap()
				}
			} else if(tab.index === '1') {
				if(this.hasdata(this.selectgd)) {
					this.createGdMap()
				}
			}
		}
		changeMonth(monthDate,calendarIndex ) {
			this.beginMonth = this.$moment(monthDate).format('YYYY-MM-DD')
			this.endMonth = this.$moment(monthDate).add(1,'M').endOf('month').format('YYYY-MM-DD')
			this.getHasLocationsDay()
		}
		selectUser(row) {
			this.selectuser = row;
			this.createuserMap()
		}
		createuserMap() {
			this.getUserInfo()
			this.getData()
			this.getHasLocationsDay()
		}
		selectGd(row) {
			this.selectgd = row;
			this.createGdMap()
		}
		createGdMap() {
			this.markers=[]
			this.circles=[]

			const marker = [ this.selectgd.zbjd, this.selectgd.zbwd];
			this.center=marker;
			this.zoom.zoom = 24
			let newmarker = {
				position: [marker],
				vid: this.selectgd.gdid,
				events: {
					mouseover:(e) => {
						this.window.visible = false
						this.window.info.name = this.selectgd.gdmc
						this.window.position = marker
						this.$nextTick(() => {
							this.window.visible = true

						})
					},
					mouseout:(e) => {
						this.window.visible = false
						this.window.info.name = ''
						this.$nextTick(() => {
							this.window.visible = false
						})
					}
				}
			};
			this.markers.push(newmarker);
			let newcircle = {
				center: [marker],
				radius: this.selectgd.dkjl,
				fillOpacity: 0.5,
				events: {
					click: (e) => {
					}
				}
			}
			this.circles.push(newcircle);
			this.getBcInfo()
			this.getHasLocationsDay()
			this.getData()
		}
		init (id) {
			this.polylines = []
			this.getData()
			// this.getHasLocationsDay();
		}
		getUserInfo() {
			this.$request({
				method: 'get',
				url: '/bjba/yhgl/getglxx2',
				params:{userid:this.selectuser.id}
			}).then((response)=>{
				this.bm =response.data.bm;
				this.gd = response.data.gd
				this.markers=[]
				this.circles=[]

				if(this.gd && this.gd.length>0) {
					var _that = this;
					for(var i=0;i<this.gd.length;i++) {
						const element = this.gd[i]
						const marker = [ this.gd[i].zbjd, this.gd[i].zbwd];
						if(i===0) {this.center=marker;this.zoom.zoom = 24}
						let newmarker = {
							position: [marker],
							vid: element.gdid,
							events: {
								mouseover:(e) => {
									_that.window.visible = false
									_that.window.info.name = element.gdmc
									_that.window.position = marker
									this.$nextTick(() => {
										_that.window.visible = true

									})
								},
								mouseout:(e) => {
									_that.window.visible = false
									_that.window.info.name = ''
									this.$nextTick(() => {
										_that.window.visible = false
									})
								}
							}
						};


						this.markers.push(newmarker);
						let newcircle = {
							center: [marker],
							radius: element.dkjl,
							fillOpacity: 0.5,
							events: {
								click: (e) => {
								}
							}
						}
						this.circles.push(newcircle);
					}
				}
			})
		}
		getBcInfo() {
			this.$request({
				method: 'get',
				url: '/bjba/map/getBcTime/'+this.selectgd.gdid
			}).then((res)=>{
				if(res.data.data && res.data.data.length>0) {
					for(var i=0;i<res.data.data.length;i++){
						if(res.data.data[i].bclx=='1'){
							this.bcxxForm.morbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
						}else if(res.data.data[i].bclx=='2'){
							this.bcxxForm.aftbc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
						} else if(res.data.data[i].bclx=='3'){
							this.bcxxForm.evebc.time = [res.data.data[i].sbsj,res.data.data[i].xbsj]
						}
					}
				}
			})
		}
		getData() {
			var type = 1;
			if(this.activeName === 'user') type=1
			else if(this.activeName ==='gd') type=2
			if(type ===1) {
				if(!this.selectuser.id) {
					this.$message.warning("请选择用户")
					return
				}
				if(!this.time.startDate || !this.time.endDate) {
					this.$message.warning("请选择日期")
					return
				}
				this.getTraceDate(1)
			} else if(type ===2) {
				if(!this.selectgd.gdid) {
					this.$message.warning("请选择岗点")
					return
				}
				if(!this.time.startDate || !this.time.endDate) {
					this.$message.warning("请选择日期")
					return
				}

				this.getTraceDate(2)
			}

		}
		getTraceDate(type) {
			this.polylines = []
			this.markers2 =[]
			var _that = this
			let loadingInstance1 = Loading.service({ fullscreen: true });
			var beginDay = this.$moment(this.time.startDate).format('YYYY-MM-DD');
			var endDay = this.$moment(this.time.endDate).format('YYYY-MM-DD');
			let url = ''
			let params = {beginDay:beginDay,endDay:endDay}
			if(type === 1) {
				url = '/bjba/tpatrollog/getTraceDataByUser'
				params.userid = this.selectuser.id
			}
			else if(type === 2) {
				url = '/bjba/tpatrollog/getTraceDataByGd'
				params.gdid = this.selectgd.gdid
			}

			this.$request({
				method: 'get',
				url: url,
				params:params
			}).then((response)=>{
				loadingInstance1.close()

				if(response.data) {
					if(!this.hasdata(response.data.data) ){
						this.$message.warning("暂无轨迹")
						return
					}
					for(const key in response.data.data){
						let datalist = response.data.data[key]
						if(datalist && datalist.length >0) {
							let path =[]
							for(var i =0;i < datalist.length; i++) {
								const position =[datalist[i].lon,datalist[i].lat];
								if(i===0) {this.center=position;this.zoom.zoom = 24}

								path.push(position)
								const element = datalist[i]
								let newmarker ={}
								if( type ===1 ){
									newmarker = {
										position: [position],
										vid: element.id,
										events: {
											mouseover:(e) => {
												_that.window.visible = false
												_that.window.info.name = element.gdmc
												_that.window.info.placeName = element.plcaeName
												_that.window.info.time = element.time
												_that.window.position = position
												this.$nextTick(() => {
													_that.window.visible = true

												})
											},
											mouseout:(e) => {
												_that.window.visible = false
												_that.window.info.name = ''
												_that.window.info.placeName = ''
												_that.window.info.time = ''
												this.$nextTick(() => {
													_that.window.visible = false
												})
											}
										}
									};
								} else if( type ===2 ) {
									newmarker = {
										position: [position],
										vid: element.id,
										events: {
											mouseover:(e) => {
												_that.window.visible = false
												_that.window.info.name = element.gdmc
												_that.window.info.userName = element.userName
												_that.window.info.placeName = element.plcaeName
												_that.window.info.time = element.time
												_that.window.position = position
												this.$nextTick(() => {
													_that.window.visible = true

												})
											},
											mouseout:(e) => {
												_that.window.visible = false
												_that.window.info.name = ''
												_that.window.info.placeName = ''
												_that.window.info.userName = ''
												_that.window.info.time = ''
												this.$nextTick(() => {
													_that.window.visible = false
												})
											}
										}
									};
								}

								this.markers2.push(newmarker);
							}
							let newpolyline = {
								path:path,
								events: {
									mouseover:(e) => {
										_that.window.visible = false
										let x = e.lnglat.lng;
										let y = e.lnglat.lat;
										let marker = [x, y];
										_that.window.info.date = key
										_that.window.position = marker
										this.$nextTick(() => {
											_that.window.visible = true

										})
									},
									mouseout:(e) => {
										_that.window.visible = false
										_that.window.info.date = ''
										this.$nextTick(() => {
											_that.window.visible = false
										})
									},
									end: (e) => {
										let newPath = e.target.getPath().map(point => [point.lng, point.lat]);
									}
								},
								editable: false,
								color: _that.colorList[Math.round(Math.random()*4)]
							}
							this.polylines.push(newpolyline)
						}

					}

				}
			}).catch((err)=>{
				loadingInstance1.close()
				console.log(err)
			});
		}
		pageUser(page) {
			this.userCurrentPage = page
			this.getUserList()
		}
		pageUser1(page) {
			this.userCurrentPage1 = page
			this.getGdList()
		}
		hasdata(obj) {
			for (var i in obj) { // 如果不为空，则会执行到这一步，返回true
				return true
			}
			return false // 如果为空,返回false
		}
		getUserList() {
			this.loading = true
			this.$request({
				method: 'get',
				url: '/bjba/yhgl/getUserList',
				params:{page:this.userCurrentPage,pagesize:10,dept:this.form.bmid,name:this.form.name}
			}).then((response)=>{
				this.loading = false
					if(response.data.data) {
						this.userList = response.data.data;
						this.total = response.data.total
					} else {
						this.userList = []
						this.total= 0
					}
			}).catch((err)=>{
				console.log(err)
			});
		}
		getGdList() {
			this.loading1 = true
			this.$request({
				method: 'get',
				url: '/bjba/map/getGdPage2',
				params:{page:this.userCurrentPage1,pagesize:10,bmid:this.form1.bmid,gdmc:this.form1.name}
			}).then((response)=>{
				this.loading1 = false
					if(response.data) {
						this.gdList =response.data.content
						this.total1 = response.data.totalElements
					} else {
						this.gdList = []
						this.total1= 0
					}
			}).catch((err)=>{
				console.log(err)
			});
		}
		getHasLocationsDay() {
			var type = 1;
			if(this.activeName === 'user') type=1
			else if(this.activeName =='gd') type=2
			this.$request({
				method: 'get',
				url: '/bjba/tpatrollog/hasTraceDay',
				params:{id:type===1?this.selectuser.id:this.selectgd.gdid,beginDay:this.beginMonth,endDay:this.endMonth,type:type}
			}).then((response)=>{
				this.hasTraceDays=response.data.data
			}).catch((err)=>{
				console.log(err)
			});
		}
		changeIndex1(value) {
			this.userCurrentPage = 1;
			this.getUserList();
		}
		changeIndex2(value) {
			this.userCurrentPage1 = 1;
			this.getGdList();
		}
		get gdmc() {
			if(!this.gd || this.gd.length==0) return ''
			else {
			return 	this.gd.map(function(obj,index){
					return obj.gdmc;
				}).join(",");
			}
		}
		get zbsj() {
			if(this.bcxxForm.morbc.time[0] && this.bcxxForm.morbc.time[1]) return this.bcxxForm.morbc.time[0]+'-'+this.bcxxForm.morbc.time[1]
			else return ''
		}
		get aftbsj() {
			if(this.bcxxForm.aftbc.time[0] && this.bcxxForm.aftbc.time[1]) return this.bcxxForm.aftbc.time[0]+'-'+this.bcxxForm.aftbc.time[1]
			else return ''
		}
		get wbsj() {
			if(this.bcxxForm.evebc.time[0] && this.bcxxForm.evebc.time[1]) return this.bcxxForm.evebc.time[0]+'-'+this.bcxxForm.evebc.time[1]
			else return ''
		}
	}
</script>

<style lang="scss">
	.MapPopBox  {
		.DeviceInfo{
			display: flex;
			align-items: center;
			justify-content: space-between;
			.ImgBox {
				width: 120px;
				height: 120px;
				flex: 0 0 auto;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.item {
				font-size: 14px;
				width: 190px;
				padding-left: 10px;
				flex: 1 1 auto;
				ul, li {
					color: #303133;
					padding: 0;
					list-style: none;
				}
				> li {
					font-size: 14px;
					padding: 2px;
					display: -webkit-box;
					display: -ms-flexbox;
					display: flex;
					> .item-title {
						-webkit-box-flex: 0;
						-ms-flex: 0 0 auto;
						flex: 0 0 auto;
					}
					> .item-info {
						-webkit-box-flex: 1;
						-ms-flex: 1 1 auto;
						flex: 1 1 auto;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
				.item-title {
					font-weight: bold;
				}
			}
		}
	}

	.has_message {
		position: relative;
		&:before {
			position: absolute;
			content: "";
			top: -3px;
			right: -10px; /*改成：right: -13px; 圆点显示在右侧*/
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: #e98b7f;
		}
		&:after {
		}
	}
	
</style>
<style type="text/css">
.amap-logo{
		display: none;
		opacity:0 !important;
	}
	.amap-copyright{
		opacity:0;
	}
</style>
